import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import career1 from '../assets/images/imgs/Career 1 copy.jpg'
import base1 from '../assets/images/bgimgs/base1.png'
import base2 from '../assets/images/bgimgs/base2.png'
import base3 from '../assets/images/bgimgs/base3.png'
import base4 from '../assets/images/bgimgs/base4.png'
import base5 from '../assets/images/bgimgs/base5.png'
import base6 from '../assets/images/bgimgs/base6.png'
import hover1 from '../assets/images/bgimgs/hover1.png'
import hover2 from '../assets/images/bgimgs/hover2.png'
import hover3 from '../assets/images/bgimgs/hover3.png'
import hover4 from '../assets/images/bgimgs/hover4.png'
import hover5 from '../assets/images/bgimgs/hover5.png'
import hover6 from '../assets/images/bgimgs/hover6.png'
import trueImg from '../assets/images/trueImg.png'
import falseImg from '../assets/images/falseImg.png'
import career3 from '../assets/images/imgs/Career 3.png'

export default function Career() {
    const { t } = useTranslation();
    
    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('career');
    }, [])
    return (
        <div>
            <section className="min-h-[calc(100vh-80px)] flex flex-col gap-[20px] lg:flex-row justify-center items-center nc px-[20px] lg:px-[100px]">
                <div className="flex flex-col gap-[20px]">
                    <div className="is-slideup text-2xl lg:text-6xl">
                        <h2 className="pl-[50px] uppercase nc font-black" style={{ fontFamily: "Time New Roman" }}>190</h2>
                        <h2 className="w-1/2 lg:w-[300px] 2xl:w-[500px] uppercase nc font-black">{t('employees_united')}</h2>
                        <h2 className="text-end w-1/2 lg:w-[350px] 2xl:w-[500px] uppercase text-[#9794AF]">{t('byCommon')}</h2>
                    </div>
                    <div>
                        <h3 className="text-lg lg:text-xl 2xl:text-3xl nc">{t('our_edge')}</h3>
                        <h3 className="max-w-full lg:max-w-[400px] 2xl:max-w-[600px] text-lg lg:text-xl 2xl:text-3xl text-[#D0A847] font-thin">{t('specialists_desc')}</h3>
                    </div>
                </div>
                <div className="min-w-full lg:min-w-[600px] 2xl:min-w-[900px]">
                    <img className="w-full lg:w-[600px] 2xl:w-[900px]" src={career1} alt="" />
                </div>
            </section>

            <section className="nc flex flex-col items-center justify-center px-[20px] lg:px-[100px] gap-[50px] py-[50px]">
                <div className="flex flex-col items-center justify-center gap-[20px]">
                    <h1 className="is-slideup text-lg lg:text-3xl 2xl:text-5xl text-center">{t('limitless_growth')}</h1>
                    <h2 className="text-md lg:text-xl 2xl:text-2xl text-center px-[10px] 2xl:px-[100px]">{t('growth_standards_desc')}</h2>
                </div>
                <div className="flex flex-wrap lg:flex-nowrap gap-[20px] justify-between">
                    <div className="w-1/3 lg:w-1/4 2xl:w-[14%] group cursor-pointer">
                        <img src={base1} className="max-w-[150px] 2xl:max-w-[100px] m-auto group-hover:hidden" alt="" />
                        <img src={hover1} className="max-w-[150px] 2xl:max-w-[100px] m-auto hidden group-hover:block" alt="" />
                        <h3 className="max-w-[220px] text-center">{t('recruitment')}</h3>
                    </div>
                    <div className="w-1/3 lg:w-1/4 2xl:w-[14%] group cursor-pointer">
                        <img src={base2} className="max-w-[150px] 2xl:max-w-[100px] m-auto group-hover:hidden" alt="" />
                        <img src={hover2} className="max-w-[150px] 2xl:max-w-[100px] m-auto hidden group-hover:block" alt="" />
                        <h3 className="max-w-[220px] text-center">{t('onboarding')}</h3>
                    </div>
                    <div className="w-1/3 lg:w-1/4 2xl:w-[14%] group cursor-pointer">
                        <img src={base3} className="max-w-[150px] 2xl:max-w-[100px] m-auto group-hover:hidden" alt="" />
                        <img src={hover3} className="max-w-[150px] 2xl:max-w-[100px] m-auto hidden group-hover:block" alt="" />
                        <h3 className="max-w-[220px] text-center">{t('training')}</h3>
                    </div>
                    <div className="w-1/3 lg:w-1/4 2xl:w-[14%] group cursor-pointer">
                        <img src={base4} className="max-w-[150px] 2xl:max-w-[100px] m-auto group-hover:hidden" alt="" />
                        <img src={hover4} className="max-w-[150px] 2xl:max-w-[100px] m-auto hidden group-hover:block" alt="" />
                        <h3 className="max-w-[220px] text-center">{t('performance')}</h3>
                    </div>
                    <div className="w-1/3 lg:w-1/4 2xl:w-[14%] group cursor-pointer">
                        <img src={base5} className="max-w-[150px] 2xl:max-w-[100px] m-auto group-hover:hidden" alt="" />
                        <img src={hover5} className="max-w-[150px] 2xl:max-w-[100px] m-auto hidden group-hover:block" alt="" />
                        <h3 className="max-w-[220px] text-center">{t('talent_development')}</h3>
                    </div>
                    <div className="w-1/3 lg:w-1/4 2xl:w-[14%] group cursor-pointer">
                        <img src={base6} className="max-w-[150px] 2xl:max-w-[100px] m-auto group-hover:hidden" alt="" />
                        <img src={hover6} className="max-w-[150px] 2xl:max-w-[100px] m-auto hidden group-hover:block" alt="" />
                        <h3 className="max-w-[220px] text-center">{t('employee_engagement')}</h3>
                    </div>
                </div>
            </section>

            <section className="min-h-[calc(100vh-80px)] flex flex-col gap-[30px] lg:flex-row justify-center items-center nc px-[20px] lg:px-[100px]">
                <div className="flex flex-col gap-[50px]">
                    <h1 className="is-slideup text-xl lg:text-5xl 2xl:text-5xl font-black"><span className="font-thin">{t('interesting_work')} </span> {t('brilliant_opportunities')}</h1>
                    <div className="flex flex-col gap-[20px] text-lg lg:text-xl">
                        <h2 className="font-thin"><span className="font-black">{t('no_restrictions')} </span>{t('restrictions_desc')}</h2>
                        <h2 className="font-thin"><span className="font-black">{t('successful_participant')} </span>{t('participant_desc')}</h2>
                        <h2 className="font-thin"><span className="font-black">{t('exciting_work')} </span>{t('endless_opportunities')}</h2>
                    </div>
                </div>
                <div className="min-w-full lg:min-w-[700px] 2xl:min-w-[1000px]">
                    <img className="w-full lg:w-[700px] 2xl:w-[1000px]" src={career3} alt="" />
                </div>
            </section>

            <section className="nc flex flex-col gap-[20px] px-[20px] lg:px-[100px] 2xl:px-[200px] items-center justify-center pb-[100px]">
                <h1 className="is-slideup text-lg lg:text-3xl 2xl:text-5xl text-center font-bold">{t('workplace_inspire')}</h1>
                <h2 className="text-md lg:text-xl 2xl:text-2xl text-start font-thin mb-[20px]">{t('culture_desc_long')}</h2>

                <div className="flex flex-col lg:flex-row justify-center items-center h-full gap-[20px]">
                    <div className="flex flex-col gap-[20px] max-w-full lg:max-w-[600px] 2xl:max-w-[800px]">
                        <h2 className="underline underline-offset-[8px] text-lg lg:text-2xl 2xl:text-4xl text-center">{t('what_defines_us')}</h2>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={trueImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('honesty')}</h2>
                                <h3>{t('honesty_desc')}</h3>
                            </div>
                        </div>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={trueImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('safety')}</h2>
                                <h3>{t('safety_env_desc')}</h3>
                            </div>
                        </div>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={trueImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('trust')}</h2>
                                <h3>{t('trust_desc')}</h3>
                            </div>
                        </div>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={trueImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('support')}</h2>
                                <h3>{t('support_desc')}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="w-full bg-[#D0A645] h-[2px] lg:h-[calc(100vh-400px)] 2xl:h-[calc(100vh-500px)] lg:w-[2px] mx-[10px] lg:mx-[50px]"></div>
                    <div className="flex flex-col gap-[20px] max-w-full lg:max-w-[600px]">
                        <h2 className="underline underline-offset-[8px] text-lg lg:text-2xl 2xl:text-4xl text-center">{t('what_we_leave')}</h2>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={falseImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('negativity')}</h2>
                                <h3>{t('negativity_desc')}</h3>
                            </div>
                        </div>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={falseImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('excuses')}</h2>
                                <h3>{t('excuses_desc')}</h3>
                            </div>
                        </div>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={falseImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('individualism')}</h2>
                                <h3>{t('individualism_desc')}</h3>
                            </div>
                        </div>
                        <div className="flex gap-[20px]">
                            <img className="w-[60px] h-[60px]" src={falseImg} alt="" />
                            <div className="">
                                <h2 className="text-lg lg:text-2xl 2xl:text-4xl font-black">{t('lack_balance')}</h2>
                                <h3>{t('balance_desc')}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}